import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2A12555B-0CBC-4FC9-9F86-88F7785B3B2C
 * name vector-rectangle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-rectangle.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const VectorRectangleIcon = createSvgIcon(<><path d="M2,4H8V6H16V4H22V10H20V14H22V20H16V18H8V20H2V14H4V10H2V4M16,10V8H8V10H6V14H8V16H16V14H18V10H16M4,6V8H6V6H4M18,6V8H20V6H18M4,16V18H6V16H4M18,16V18H20V16H18Z" /></>, 'VectorRectangleIcon');
export default VectorRectangleIcon